import React from 'react';
import T from 'prop-types';
// components
import CircleProgress from '../../../components/CircleProgress/CircleProgress';
import Icon from '../../../components/Icon/Icon';
// styles
import classnames from 'classnames/bind';
import styles from './ModuleCircle.mod.css';

const cx = classnames.bind(styles);

const ModuleCircle = ({
  className,
  name,
  state,
  tablet,
  secondary,
  progress = 0,
  iconType,
  ...otherProps
}) => (
  <div className={cx('circle', className, state, { tablet })} {...otherProps}>
    <div className={cx('name', { withIcon: !!iconType })}>{name}</div>
    {iconType && <Icon className={cx('icon', { secondary })} type={iconType} />}
    {state === 'current' && (
      <CircleProgress
        progress={progress}
        className={cx('circle-progress')}
        initialAnimation
        {...otherProps}
      />
    )}
  </div>
);

ModuleCircle.propTypes = {
  name: T.oneOfType([T.string, T.number]),
  iconType: T.string,
  state: T.oneOf(['incomplete', 'complete', 'current', 'extra']),
  className: T.string,
  progress: T.number
};

export default ModuleCircle;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/components/ModuleCircle.jsx